import { render, staticRenderFns } from "./posters.vue?vue&type=template&id=803c1c12&scoped=true&"
import script from "./posters.vue?vue&type=script&lang=js&"
export * from "./posters.vue?vue&type=script&lang=js&"
import style0 from "./posters.vue?vue&type=style&index=0&id=803c1c12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "803c1c12",
  null
  
)

export default component.exports